import React from 'react';
import { capitalizeFirstLetter } from '../../../util';

import { Row, TableData } from 'components/common/tableElements';

const AmazonOrderSearchResult = ({ result, clickAction, even }) => {
  const itemDescriptions = (result['OrderItems'] || []).map((orderItem) => {
    return `${orderItem['QuantityOrdered']} ${orderItem['Title']}`;
  });
  const orderStatus = result['OrderStatus'];
  const orderNumber = result['AmazonOrderId'];

  return (
    <Row onClick={(event) => clickAction(event, result)} hoverPointer={true} even={even}>
      <TableData>{orderNumber}</TableData>
      <TableData>{itemDescriptions.join(', ')}</TableData>
      <TableData>{orderStatus && capitalizeFirstLetter(orderStatus)}</TableData>
    </Row>
  );
};

export default AmazonOrderSearchResult;
